import { CustomTooltip } from 'components/Labels'
import { useState } from 'react'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'
import { IPermission } from '../types/userTypes'

export const CSGridPermissions = (params: any) => {
  const { permissions } = params.data

  const rowIndex = params.node.rowIndex
  const totalRows = params.api.getDisplayedRowCount()

  const [tooltipPosition, setTooltipPosition] = useState(PositionEnum.bottom)

  // Dynamically set position on mouse over
  const handleMouseEnter = () => {
    if (rowIndex >= totalRows - 3) {
      setTooltipPosition(PositionEnum.top)
    } else if (rowIndex <= 2) {
      setTooltipPosition(PositionEnum.bottom)
    } else {
      setTooltipPosition(PositionEnum.bottom)
    }
  }

  const getGridPermissionsToDisplay = () => {
    if (!permissions || permissions.length === 0) return []
    return permissions.length <= 2 ? permissions : permissions.slice(0, 2)
  }

  return (
    <Div onMouseEnter={handleMouseEnter}>
      <CustomTooltip
        tooltipText={
          <TooltipContent>
            {permissions.length > 0
              ? permissions.map((permission: IPermission) => (
                  <div key={permission.permissionId}>{permission.description}</div>
                ))
              : 'No permission found'}
          </TooltipContent>
        }
        position={tooltipPosition}
        positionTooltipArrow={30}
        tooltipStyles={{
          maxWidth: '50rem',
          wordWrap: 'break-word',
          transform: 'translateX(-30%)',
          zIndex: 9999,
        }}
      >
        <PermissionText>
          {getGridPermissionsToDisplay().map((permission: IPermission, i: number) => (
            <span key={permission.permissionId}>
              {permission.description}
              {permissions.length > 2 && i === 1 ? '...' : ''}
            </span>
          ))}
          {permissions.length === 0 && 'NA'}
        </PermissionText>
      </CustomTooltip>
    </Div>
  )
}

const Div = styled.div`
  display: flex;
  gap: 0.5rem;
  white-space: nowrap;
  overflow: visible;
`

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

const PermissionText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
`
